import brandCreditCard from "scripts/util/brandCreditCard";

const maskInputDataCreditCard = () => {
    const CardBehaviour = (val) => {
        const elCardBrandsImg = $('.card-brands img');
        const elCardBrandsInput = $('.card-brands img');

        const brand = brandCreditCard(val);
        const brandIsEmpty = (brand === '');

        if (!brandIsEmpty) {
            const elBrand = $(`#${brand}`);

            elCardBrandsInput.prop('checked', false);
            elCardBrandsImg.removeClass('checked');

            elBrand.prop('checked', true);
            elBrand.parent().find('img').addClass('checked');
        } else if (brandIsEmpty && val.length <= 7) {
            elCardBrandsInput.prop('checked', false);
            elCardBrandsImg.removeClass('checked');
        }

        if (brand === 'amex') {
            return '0000 000000 00000'
        } else if (brand === 'diners') {
            return '00000 0000 00000';
        }

        return '0000 0000 0000 0000';
    };

    const cardOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(CardBehaviour.apply({}, arguments), options);
        },
        onPaste: function (val, e, field, options) {
            field.mask(CardBehaviour.apply({}, arguments), options);
        },
    };

    $('#number').mask(CardBehaviour, cardOptions);
}

export default maskInputDataCreditCard;



// WEBPACK FOOTER //
// ./scripts/miscellaneous/maskInputDataCreditCard.js